import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react-hooks/exhaustive-deps */
import { Icon, toast } from '@livable/saas-react-components';
import { Button, Checkbox, FormControlLabel, FormGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { track, events } from 'src/configs/amplitude';
import { useStore } from 'src/stores';
import { refreshCycleBill } from './refreshCycleBill';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { exportCSV } from 'src/utils/exportCSV';
import { useOldServicePeriodConfirm } from 'src/components/allocations/OldServicePeriod';
import { ALLOCATION_BILL_LOOKUP, resolveAllocationBillLookup, shouldHoldFoundBill, shouldReleaseHeldBill } from './allocationBillLookup';
import { isBillAutomationInFlight } from './BillAutomationExtraction';
import BillDetailsForm from './billDetailsForm';
import { succeeded, unlessRefused } from '../requestOutcome';
import Comparison from './comparison';
import useStyles from './styles';
import { useAllocationRemove } from './useAllocationRemove';
const NOT_LOADED = '—';
const isFigure = value => typeof value === 'number' && Number.isFinite(value);
const asMoney = value => isFigure(value) ? "$".concat(value.toFixed(2)) : NOT_LOADED;
const asPercent = value => isFigure(value) ? "".concat(value, "%") : NOT_LOADED;
const BillDetails = observer(props => {
  var _property$allocations, _utility$bill, _property$allocations4, _property$allocations5, _utility$bill6, _property$allocations6, _property$allocations7, _property$allocations8, _utility$bill0, _utility$bill17, _utility$bill18, _utility$comparison, _utility$comparison2, _utility$comparison3, _utility$comparison4, _utility$comparison5, _utility$comparison6;
  const handleClose = props.handleClose,
    _props$property = props.property,
    property = _props$property === void 0 ? {} : _props$property,
    showPreview = props.showPreview,
    isSubmeterUtility = props.isSubmeterUtility,
    onSubmeterBillSaved = props.onSubmeterBillSaved,
    hasSavedMeterRows = props.hasSavedMeterRows,
    hasReadTable = props.hasReadTable;
  const classes = useStyles();
  const modalFooterClasses = useModalFooterStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const page = 'Apply Billing';
  const currentCompany = store.homeDashboardStore.getCurrentCompany || {};
  const billingTab = currentCompany.billingTab;
  const applyBill = billingTab.applyBill || {};
  const billingCycleId = applyBill.billingCycleId;
  const isTableReady = applyBill.status === 'TableReady';
  const isStatementSent = applyBill.status === 'TableReadyStatementSent';
  const propertyId = property.id;
  const setApplyBillAutosave = billingTab.setApplyBillAutosave;
  const utilityId = applyBill.utilityId;
  const utility = ((_property$allocations = property.allocations) === null || _property$allocations === void 0 ? void 0 : _property$allocations.utilityById.get(billingCycleId + utilityId)) || {};
  const allocationRemove = useAllocationRemove({
    property
  });
  const oldServicePeriod = useOldServicePeriodConfirm();
  // Until billed: then it is what residents were billed from. Property-service refuses it all the same.
  const mayRemoveAllocation = !!((_utility$bill = utility.bill) !== null && _utility$bill !== void 0 && _utility$bill.id) && !isStatementSent && !!utility.isEditable;
  const isReviewChecked = utility.isReviewChecked;
  const setReviewChecked = utility.setReviewChecked;
  const utilityAllocations = toJS(utility.allocations) || [];
  const sortedAllocations = utilityAllocations.sort((a, b) => {
    if (a.isBillable !== b.isBillable) return b.isBillable - a.isBillable;
    return a.unitName.localeCompare(b.unitName, undefined, {
      numeric: true
    });
  });
  const billableAllocations = sortedAllocations.filter(allocation => allocation.isBillable);
  const nonBillableAllocations = sortedAllocations.filter(allocation => !allocation.isBillable);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showComparisonModal = _useState2[0],
    setShowComparisonModal = _useState2[1];
  const getAllocationComparison = async data => {
    const resp = await store.allocations.getAllocationComparisonAsync.run(data);
    return resp;
  };
  const postTableApproval = async data => {
    const resp = await store.allocations.postTableApprovalAsync.run(data);
    return resp;
  };
  const postReview = async data => {
    const resp = await store.allocations.postReviewAsync.run(data);
    return resp;
  };
  const getFileId = () => {
    var _property$allocations2, _property$allocations3, _utility$bill2, _utility$bill3, _utility$bill4, _utility$bill5;
    return (_property$allocations2 = property.allocations) !== null && _property$allocations2 !== void 0 && (_property$allocations2 = _property$allocations2.tempFileData) !== null && _property$allocations2 !== void 0 && _property$allocations2.fileId ? (_property$allocations3 = property.allocations) === null || _property$allocations3 === void 0 || (_property$allocations3 = _property$allocations3.tempFileData) === null || _property$allocations3 === void 0 ? void 0 : _property$allocations3.fileId : (_utility$bill2 = utility.bill) !== null && _utility$bill2 !== void 0 && _utility$bill2.redactedFileId ? (_utility$bill3 = utility.bill) === null || _utility$bill3 === void 0 ? void 0 : _utility$bill3.redactedFileId : (_utility$bill4 = utility.bill) !== null && _utility$bill4 !== void 0 && _utility$bill4.fileId ? (_utility$bill5 = utility.bill) === null || _utility$bill5 === void 0 ? void 0 : _utility$bill5.fileId : '';
  };

  // Bills API response (billId, propertyId, status, data, errors, createdAt, updatedAt) after posting file for automation
  const billAutomationResponse = (_property$allocations4 = (_property$allocations5 = property.allocations) === null || _property$allocations5 === void 0 || (_property$allocations5 = _property$allocations5.tempFileData) === null || _property$allocations5 === void 0 ? void 0 : _property$allocations5.billAutomationResponse) !== null && _property$allocations4 !== void 0 ? _property$allocations4 : null;
  const isBillExtractionEnabled = store.account.featureFlagsStore.getIsBillExtractionEnabled;
  const POLL_INTERVAL_MS = 5000;

  // The bill this allocation was made from, once it has been allocated. Read off the allocation
  // table rather than asked for, and preferred to asking the cycle — see allocationBillLookup.
  const allocatedSourceBillId = (_utility$bill6 = utility.bill) === null || _utility$bill6 === void 0 ? void 0 : _utility$bill6.sourceBillId;
  // Whether the bill on screen was brought back or uploaded here a moment ago. Only a recovered one
  // may be replaced once the allocation turns out to name a different bill -- see allocationBillLookup.
  const heldBillWasRecovered = !!((_property$allocations6 = property.allocations) !== null && _property$allocations6 !== void 0 && (_property$allocations6 = _property$allocations6.tempFileData) !== null && _property$allocations6 !== void 0 && _property$allocations6.wasRecovered);
  // A bill being uploaded to replace what is on screen. The screen clears the old one before the
  // new one exists, and that gap must not be filled by going and fetching the old one back.
  //
  // Read from the screen rather than from whichever request happens to be in flight. A replacement
  // begins by letting go of the bill and only then fetches the file it is replacing it with, so a
  // flag tied to the upload would come on after the gap had already opened.
  const hasUnfinishedReplacement = !!((_property$allocations7 = property.allocations) !== null && _property$allocations7 !== void 0 && (_property$allocations7 = _property$allocations7.tempFileData) !== null && _property$allocations7 !== void 0 && _property$allocations7.hasUnfinishedReplacement);
  // An allocation made from a bill that was removed here: that bill is not to be fetched back (LB-6028).
  const releasedAllocationBillId = (_property$allocations8 = property.allocations) === null || _property$allocations8 === void 0 || (_property$allocations8 = _property$allocations8.tempFileData) === null || _property$allocations8 === void 0 ? void 0 : _property$allocations8.releasedAllocationBillId;
  /**
   * Whether a removal here has let go of a bill since `releasedWhenAsked` was read, which an answer still out must not then
   * write back (LB-6028). Read off the store when the answer lands: the screen resets at once, while what cancels a
   * request this effect started runs only on the next render.
   */
  const releasedSince = releasedWhenAsked => {
    var _property$allocations9, _property$allocations0;
    return ((_property$allocations9 = (_property$allocations0 = property.allocations) === null || _property$allocations0 === void 0 || (_property$allocations0 = _property$allocations0.tempFileData) === null || _property$allocations0 === void 0 ? void 0 : _property$allocations0.releasedAllocationBillId) !== null && _property$allocations9 !== void 0 ? _property$allocations9 : null) !== (releasedWhenAsked !== null && releasedWhenAsked !== void 0 ? releasedWhenAsked : null);
  };
  // A source bill this screen has already looked for and not found. A ref rather than state: it
  // must not cause a render of its own, and the pass that reads it is the one the release below
  // triggers. Reset by remounting, which is what stepping to another utility does -- so a bill
  // that was merely unreachable gets another chance the next time the modal is opened.
  const missingSourceBillId = useRef('');
  const attachedFileId = getFileId();

  // The uploaded document is only held for as long as this modal is open — closing it, or stepping to
  // the next utility, clears it. Ask the service for the bill behind what is on screen now, so coming
  // back to a cycle shows the bill that is already there rather than an empty form (LB-5822).
  useEffect(() => {
    var _utility$bill7;
    if (!isBillExtractionEnabled) return;
    const lookup = resolveAllocationBillLookup({
      heldBillId: billAutomationResponse === null || billAutomationResponse === void 0 ? void 0 : billAutomationResponse.billId,
      heldBillStatus: billAutomationResponse === null || billAutomationResponse === void 0 ? void 0 : billAutomationResponse.status,
      heldBillWasRecovered,
      hasUnfinishedReplacement,
      sourceBillId: allocatedSourceBillId,
      missingSourceBillId: missingSourceBillId.current,
      attachedFileId,
      allocationBillId: (_utility$bill7 = utility.bill) === null || _utility$bill7 === void 0 ? void 0 : _utility$bill7.id,
      releasedAllocationBillId,
      billingCycleId,
      propertyId,
      utilityId
    });
    if (lookup === ALLOCATION_BILL_LOOKUP.none) return;
    if (lookup === ALLOCATION_BILL_LOOKUP.release) {
      var _property$allocations1, _property$allocations10;
      (_property$allocations1 = property.allocations) === null || _property$allocations1 === void 0 || _property$allocations1.setTempFileData('billAutomationResponse', null);
      (_property$allocations10 = property.allocations) === null || _property$allocations10 === void 0 || _property$allocations10.setTempFileData('wasRecovered', null);
      return;
    }
    let cancelled = false;
    (async (_utility$bill9, _property$allocations13, _property$allocations14, _property$allocations15) => {
      const resp = lookup === ALLOCATION_BILL_LOOKUP.bySourceBillId ? await store.billAutomationBillsApi.getAllocatedBillAsync.run(allocatedSourceBillId) : await store.billAutomationBillsApi.getBillForCycleAsync.run({
        billingCycleId,
        propertyId,
        utilityId
      });
      if (cancelled || releasedSince(releasedAllocationBillId)) return;
      if (!(resp !== null && resp !== void 0 && resp.isSuccessful) || !(resp !== null && resp !== void 0 && resp.response)) {
        var _utility$bill8;
        // Recorded before anything is released, because releasing is what makes this effect run
        // again: noted after, the next pass would go and ask for the same bill a second time.
        if (lookup === ALLOCATION_BILL_LOOKUP.bySourceBillId) {
          missingSourceBillId.current = allocatedSourceBillId;
        }

        // Empty means different things depending on what was asked -- see shouldReleaseHeldBill.
        if (shouldReleaseHeldBill({
          lookup,
          heldBillWasRecovered
        })) {
          var _property$allocations11;
          (_property$allocations11 = property.allocations) === null || _property$allocations11 === void 0 || _property$allocations11.setTempFileData('billAutomationResponse', null);
        }

        // No bill for this table: a later one for its property and utility may be on file, scheduled for its own month
        // (LB-6009), and the table says so rather than look as if nothing came. Not over a saved allocation: that table
        // has its bill.
        if (lookup === ALLOCATION_BILL_LOOKUP.forCycle && resp !== null && resp !== void 0 && resp.isSuccessful && !((_utility$bill8 = utility.bill) !== null && _utility$bill8 !== void 0 && _utility$bill8.id)) {
          const scheduled = await store.billAutomationBillsApi.getScheduledBillsForTableAsync.run({
            billingCycleId,
            propertyId,
            utilityId
          });
          if (!cancelled && !releasedSince(releasedAllocationBillId)) {
            var _property$allocations12, _scheduled$response;
            (_property$allocations12 = property.allocations) === null || _property$allocations12 === void 0 || _property$allocations12.setTempFileData('scheduledLaterBills', scheduled !== null && scheduled !== void 0 && (_scheduled$response = scheduled.response) !== null && _scheduled$response !== void 0 && _scheduled$response.length ? scheduled.response : null);
          }
        }
        return;
      }
      if (!shouldHoldFoundBill({
        lookup,
        bill: resp.response,
        allocationBillId: (_utility$bill9 = utility.bill) === null || _utility$bill9 === void 0 ? void 0 : _utility$bill9.id
      })) return;
      (_property$allocations13 = property.allocations) === null || _property$allocations13 === void 0 || _property$allocations13.setTempFileData('scheduledLaterBills', null);
      (_property$allocations14 = property.allocations) === null || _property$allocations14 === void 0 || _property$allocations14.setTempFileData('billAutomationResponse', resp.response);
      // Set alongside, so the banner can say this was brought back rather than just uploaded.
      (_property$allocations15 = property.allocations) === null || _property$allocations15 === void 0 || _property$allocations15.setTempFileData('wasRecovered', true);
    })();
    return () => {
      // The utility can change while this is in flight, and a bill for the one being left must not
      // land on the one being opened.
      cancelled = true;
    };
  }, [isBillExtractionEnabled, billAutomationResponse === null || billAutomationResponse === void 0 ? void 0 : billAutomationResponse.billId, billAutomationResponse === null || billAutomationResponse === void 0 ? void 0 : billAutomationResponse.status,
  // In the list because the recovery sets the bill and the flag in two steps: without it, a pass
  // that saw the bill before the flag would read it as uploaded here and never look again.
  heldBillWasRecovered, hasUnfinishedReplacement, allocatedSourceBillId, attachedFileId, (_utility$bill0 = utility.bill) === null || _utility$bill0 === void 0 ? void 0 : _utility$bill0.id, releasedAllocationBillId, billingCycleId, propertyId, utilityId]);
  useEffect(() => {
    if (!isBillExtractionEnabled) return;
    // Only while the pipeline still has the bill, Pending included. The spinner reads the same check,
    // so a bill that has settled gets its own banner rather than a spinner nothing will move (LB-5919).
    if (!isBillAutomationInFlight(billAutomationResponse)) return;
    const billId = billAutomationResponse.billId;
    const releasedWhenPolled = releasedAllocationBillId;
    // An answer that arrives after this pass has ended is for a bill the screen has moved on from --
    // let go of with "Upload another bill", or replaced, or by a removal (LB-6028) -- and writing it would put that bill straight back.
    let cancelled = false;
    const poll = async () => {
      const resp = await store.billAutomationBillsApi.getBillAsync.run(billId);
      if (!cancelled && !releasedSince(releasedWhenPolled) && resp !== null && resp !== void 0 && resp.isSuccessful && resp !== null && resp !== void 0 && resp.response) {
        var _property$allocations16;
        (_property$allocations16 = property.allocations) === null || _property$allocations16 === void 0 || _property$allocations16.setTempFileData('billAutomationResponse', resp.response);
      }
    };
    const intervalId = setInterval(poll, POLL_INTERVAL_MS);
    poll();
    return () => {
      cancelled = true;
      clearInterval(intervalId);
    };
    // The release too: a removal that keeps a bill put on screen since (useAllocationRemove) changes it and not the bill,
    // and a poll left reading the old one would drop every answer about that bill.
  }, [isBillExtractionEnabled, billAutomationResponse === null || billAutomationResponse === void 0 ? void 0 : billAutomationResponse.billId, billAutomationResponse === null || billAutomationResponse === void 0 ? void 0 : billAutomationResponse.status, releasedAllocationBillId]);
  const fileAttachedAsync = async () => {
    var _property$allocations17;
    let fileAttachedData = {};
    if ((_property$allocations17 = property.allocations) !== null && _property$allocations17 !== void 0 && (_property$allocations17 = _property$allocations17.tempFileData) !== null && _property$allocations17 !== void 0 && _property$allocations17.isDeleted) {
      var _utility$bill1;
      fileAttachedData = {
        billId: (_utility$bill1 = utility.bill) === null || _utility$bill1 === void 0 ? void 0 : _utility$bill1.id,
        fileId: null,
        isShared: false
      };
    } else if (getFileId()) {
      var _property$allocations18, _utility$bill10;
      if ((_property$allocations18 = property.allocations) !== null && _property$allocations18 !== void 0 && (_property$allocations18 = _property$allocations18.tempFileData) !== null && _property$allocations18 !== void 0 && _property$allocations18.isReducted || (_utility$bill10 = utility.bill) !== null && _utility$bill10 !== void 0 && _utility$bill10.redactedFileId) {
        var _utility$bill11, _utility$bill12, _utility$bill13, _property$allocations19;
        fileAttachedData = {
          billId: (_utility$bill11 = utility.bill) === null || _utility$bill11 === void 0 ? void 0 : _utility$bill11.id,
          fileId: (_utility$bill12 = utility.bill) !== null && _utility$bill12 !== void 0 && _utility$bill12.fileId ? (_utility$bill13 = utility.bill) === null || _utility$bill13 === void 0 ? void 0 : _utility$bill13.fileId : getFileId() ? getFileId() : '',
          redactedFileId: getFileId(),
          isShared: (_property$allocations19 = property.allocations) === null || _property$allocations19 === void 0 || (_property$allocations19 = _property$allocations19.tempFileData) === null || _property$allocations19 === void 0 ? void 0 : _property$allocations19.isShared
        };
      } else {
        var _utility$bill14, _property$allocations20;
        fileAttachedData = {
          billId: (_utility$bill14 = utility.bill) === null || _utility$bill14 === void 0 ? void 0 : _utility$bill14.id,
          fileId: getFileId(),
          isShared: (_property$allocations20 = property.allocations) === null || _property$allocations20 === void 0 || (_property$allocations20 = _property$allocations20.tempFileData) === null || _property$allocations20 === void 0 ? void 0 : _property$allocations20.isShared
        };
      }
    }
    if (fileAttachedData.billId) await store.allocations.getFileAttachedAsync.run(fileAttachedData);
  };
  const handleCheck = async () => {
    track(isReviewChecked ? events.disabled('Comparison Reviewed') : events.enabled('Comparison Reviewed'), {
      page,
      utility: applyBill.utilityName
    });
    if (!isReviewChecked) postReview({
      allocationCycleId: applyBill.allocationCycleId,
      billingCycleId,
      propertyId,
      utilityId,
      isReviewed: true
    }).then(() => getAllocationComparison({
      billingCycleId,
      propertyId,
      utilityId
    })).then(() => {
      setApplyBillAutosave(true);
      setTimeout(() => setApplyBillAutosave(false), 2000);
    });
    setReviewChecked(!isReviewChecked);
  };
  const handleEdit = () => {
    track(events.clicked('Edit Bill'), {
      page,
      utility: applyBill.utilityName
    });
    billingTab.setIsBillEdit(true);
  };
  const approveTable = async () => {
    track(events.clicked('Approve Table'), {
      page,
      utility: applyBill.utilityName
    });
    const savedBillingCycleId = billingCycleId;
    const savedUtilityId = utilityId;
    const savedAllocationCycleId = applyBill.allocationCycleId;
    billingTab.setIsModalLoading(true);
    postTableApproval({
      allocationCycleId: savedAllocationCycleId,
      billingCycleId: savedBillingCycleId,
      isApproved: true,
      isSkipped: false,
      propertyId,
      utilityId: savedUtilityId
    }).then(succeeded(store.allocations.postTableApprovalAsync)).then(() => billingTab.updateBillingSummaryTimestamp()).then(() => {
      var _store$homeDashboardS;
      return billingTab.addToPreviewQueue({
        billingCycleId: savedBillingCycleId,
        id: savedBillingCycleId + propertyId,
        portfolioId: ((_store$homeDashboardS = store.homeDashboardStore.getCurrentPortfolio) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.id) || '',
        propertyId
      });
    }).then(() => fileAttachedAsync()).then(() => {
      var _billingTab$applyBill;
      if (((_billingTab$applyBill = billingTab.applyBill) === null || _billingTab$applyBill === void 0 ? void 0 : _billingTab$applyBill.utilityId) === savedUtilityId) {
        return refreshCycleBill({
          store,
          billingTab,
          allocations: property.allocations,
          propertyId,
          billingCycleId: savedBillingCycleId,
          utilityId: savedUtilityId,
          isSubmeterUtility
        });
      }
    }).then(() => {
      var _billingTab$applyBill2, _property$allocations21;
      if (isSubmeterUtility || ((_billingTab$applyBill2 = billingTab.applyBill) === null || _billingTab$applyBill2 === void 0 ? void 0 : _billingTab$applyBill2.utilityId) !== savedUtilityId) return;
      const updatedUtility = (_property$allocations21 = property.allocations) === null || _property$allocations21 === void 0 ? void 0 : _property$allocations21.utilityById.get(savedBillingCycleId + savedUtilityId);
      if (updatedUtility !== null && updatedUtility !== void 0 && updatedUtility.billStatus) {
        billingTab.setApplyBill(_objectSpread(_objectSpread({}, billingTab.applyBill), {}, {
          status: updatedUtility.billStatus
        }));
      }
    }).then(() => toast('success', {
      body: ['Bill is successfully approved']
    })).catch(unlessRefused(error => Promise.reject(error))).finally(() => {
      var _billingTab$applyBill3;
      if (((_billingTab$applyBill3 = billingTab.applyBill) === null || _billingTab$applyBill3 === void 0 ? void 0 : _billingTab$applyBill3.utilityId) === savedUtilityId) {
        billingTab.setIsModalLoading(false);
      }
    });
  };

  // LB-6030: warns again before approving a long-past service period, but records nothing; the confirmation kept is
  // the one given when it was allocated.
  const handleSave = () => {
    var _utility$bill15, _utility$bill16;
    return oldServicePeriod.confirmIfOld([{
      endDateOnly: (_utility$bill15 = utility.bill) === null || _utility$bill15 === void 0 ? void 0 : _utility$bill15.endDateOnly,
      startDateOnly: (_utility$bill16 = utility.bill) === null || _utility$bill16 === void 0 ? void 0 : _utility$bill16.startDateOnly
    }], () => approveTable(), {
      confirmLabel: t('Approve table'),
      title: t('Approve a bill for a long-past period?')
    });
  };

  // A figure the table hasn't loaded reads as a dash, not "$undefined" or today's date.
  const serviceDates = (_utility$bill17 = utility.bill) !== null && _utility$bill17 !== void 0 && _utility$bill17.startDateOnly && (_utility$bill18 = utility.bill) !== null && _utility$bill18 !== void 0 && _utility$bill18.endDateOnly ? "".concat(moment(utility.bill.startDateOnly).format('MM/DD/YYYY'), " - ").concat(moment(utility.bill.endDateOnly).format('MM/DD/YYYY')) : NOT_LOADED;
  const summaries = [{
    title: 'Service dates',
    value: serviceDates
  }, {
    title: 'Bill amount',
    value: asMoney(utility.billTotal)
  }, {
    title: 'Deductions',
    value: asPercent(utility.deductions)
  }, {
    title: 'Total billing',
    value: asMoney(utility.allocated)
  }, {
    title: 'Recovery',
    value: asPercent(utility.recovery)
  }];
  const getResidentName = residentAccountId => store.account.profilesFullName.get(residentAccountId) || t('allocations.not_enrolled');

  // Export bill details table to CSV
  const handleExportCSV = () => {
    track(events.clicked('Export Table To CSV'), {
      page,
      utility: applyBill.utilityName
    });
    const headers = ['Unit number', 'Resident Name', 'Billable', 'Number of occupants', 'Unit occupancy factor', 'Number of days', 'Utility total'];
    const rows = sortedAllocations.map(allocation => [allocation.unitName, getResidentName(allocation.residentAccountId), allocation.isBillable ? 'Yes' : 'No', allocation.occupantsCount, allocation.occupancyFactor, allocation.daysOccupied, allocation.allocationCharge.toFixed(2)]);
    exportCSV(headers, rows, 'bill_details.csv');
  };
  const sxData = {
    color: '#4B617C'
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, showPreview && !billingTab.isBillEdit ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.infoAndEdit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.infoWrapper
  }, summaries.map((summary, index) => /*#__PURE__*/React.createElement("dl", {
    key: index
  }, /*#__PURE__*/React.createElement("dt", null, summary.title), /*#__PURE__*/React.createElement("dd", null, summary.value)))), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, !isStatementSent && /*#__PURE__*/React.createElement(Button, {
    disabled: !utility.isEditable,
    onClick: handleEdit,
    variant: "actionButton",
    'custom-attribute': '602-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), "Edit"))), /*#__PURE__*/React.createElement("div", {
    className: classes.tableWrapper
  }, /*#__PURE__*/React.createElement(TableContainer, {
    sx: {
      maxHeight: showPreview && !isStatementSent && (_utility$comparison = utility.comparison) !== null && _utility$comparison !== void 0 && _utility$comparison.isBillIncreasedBy20Percent && !((_utility$comparison2 = utility.comparison) !== null && _utility$comparison2 !== void 0 && _utility$comparison2.isReviewed) ? 400 : 560,
      overflow: 'auto'
    }
  }, /*#__PURE__*/React.createElement(Table, {
    stickyHeader: true
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "Unit number"), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "Resident Name"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Number of occupants"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Unit occupancy factor"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Number of days"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Utility total"))), /*#__PURE__*/React.createElement(TableBody, null, (() => {
    return [...billableAllocations.map((allocation, index) => /*#__PURE__*/React.createElement(TableRow, {
      key: "billable-".concat(index)
    }, /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, allocation.unitName), /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, getResidentName(allocation.residentAccountId)), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, allocation.occupantsCount), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, allocation.occupancyFactor), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, allocation.daysOccupied), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, "$", allocation.allocationCharge.toFixed(2)))), ...(nonBillableAllocations.length > 0 ? [/*#__PURE__*/React.createElement(TableRow, {
      key: "separator",
      sx: {
        color: '#4B617C',
        position: 'sticky',
        top: 53,
        zIndex: 9
      }
    }, /*#__PURE__*/React.createElement(TableCell, {
      align: "center",
      colSpan: 6,
      sx: {
        backgroundColor: '#f5f5f5',
        color: '#4B617C',
        lineHeight: '1px'
      }
    }, "The following residents are not billable yet"))] : []), ...nonBillableAllocations.map((allocation, index) => /*#__PURE__*/React.createElement(TableRow, {
      key: "non-billable-".concat(index),
      sx: {
        backgroundColor: '#f5f5f5',
        color: '#4B617C'
      }
    }, /*#__PURE__*/React.createElement(TableCell, {
      align: "left",
      sx: sxData
    }, allocation.unitName), /*#__PURE__*/React.createElement(TableCell, {
      align: "left",
      sx: sxData
    }, getResidentName(allocation.residentAccountId)), /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      sx: sxData
    }, allocation.occupantsCount), /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      sx: sxData
    }, allocation.occupancyFactor), /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      sx: sxData
    }, allocation.daysOccupied), /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      sx: sxData
    }, "$", allocation.allocationCharge.toFixed(2))))];
  })()))))), /*#__PURE__*/React.createElement("div", null, showPreview && !isStatementSent && (_utility$comparison3 = utility.comparison) !== null && _utility$comparison3 !== void 0 && _utility$comparison3.isBillIncreasedBy20Percent && !((_utility$comparison4 = utility.comparison) !== null && _utility$comparison4 !== void 0 && _utility$comparison4.isReviewed) ? /*#__PURE__*/React.createElement("div", {
    className: classes.warningBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.warningBlockData
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Your allocation amount has increased by more than 20% since last time."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Please review the comparison between the current and previous allocations and check the checkbox below."), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: isReviewChecked,
      onChange: handleCheck
    }),
    label: "I reviewed the comparison with the previous cycles."
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.warningBlockAction
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    onClick: () => {
      track(events.clicked('Review Comparison'), {
        page,
        utility: applyBill.utilityName
      });
      setShowComparisonModal(true);
    },
    'custom-attribute': '603-new-billing-module'
  }, "Review comparison")), showComparisonModal && utility.comparison ? /*#__PURE__*/React.createElement(Comparison, {
    comparison: utility.comparison,
    setShowComparisonModal: setShowComparisonModal
  }) : null) : null, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandartSmall
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      track(events.clicked('Close'), {
        page,
        utility: applyBill.utilityName
      });
      handleClose();
    },
    variant: "text",
    'custom-attribute': '605-new-billing-module'
  }, t('general.close')), /*#__PURE__*/React.createElement(Button, {
    onClick: handleExportCSV,
    size: "small",
    variant: "contained",
    'custom-attribute': '699-new-billing-module'
  }, "Export table to CSV")), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, mayRemoveAllocation && /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      track(events.clicked('Remove Allocation'), {
        page,
        utility: applyBill.utilityName
      });
      allocationRemove.request(utility.bill);
    },
    type: "button",
    variant: "actionButtonInvert",
    'custom-attribute': 'remove-allocation'
  }, "Remove allocation")), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, !isStatementSent && /*#__PURE__*/React.createElement(Button, {
    disabled: ((_utility$comparison5 = utility.comparison) === null || _utility$comparison5 === void 0 ? void 0 : _utility$comparison5.isBillIncreasedBy20Percent) && !((_utility$comparison6 = utility.comparison) !== null && _utility$comparison6 !== void 0 && _utility$comparison6.isReviewed) && !isReviewChecked && !isTableReady || !utility.isEditable,
    onClick: handleSave,
    type: "button",
    variant: "contained",
    'custom-attribute': '604-new-billing-module'
  }, t('Approve table')))))))) : /*#__PURE__*/React.createElement(BillDetailsForm, {
    billAutomationResponse: isBillExtractionEnabled ? billAutomationResponse : null,
    handleClose: handleClose,
    showPreview: showPreview,
    utility: utility,
    isSubmeterUtility: isSubmeterUtility,
    onSubmeterBillSaved: onSubmeterBillSaved,
    hasSavedMeterRows: hasSavedMeterRows,
    hasReadTable: hasReadTable
  }), allocationRemove.confirmation, oldServicePeriod.confirmation);
});
export default BillDetails;